export default {
  left_column: {
    title: 'Guthaben prüfen',
    description:
      'Gib deinen Geschenkkartencode ein, um das verbleibende Guthaben zu prüfen. Den Code findest du in deinem Geschenkkarten-PDF.',
  },
  title: 'Guthaben der Geschenkkarte prüfen',
  subtitle: 'Gib einen Geschenkkartencode ein, um das aktuelle Guthaben zu prüfen',
  error: {
    title: 'Geschenkkarte nicht gefunden!',
    description: 'Bitte gib einen gültigen Geschenkkartencode ein.',
  },
  gift_card: {
    title: 'Geschenkkarte gefunden!',
    balance: 'Guthaben',
    value: 'Wert',
    expires_at: 'Gültig bis',
  },
  form: {
    code: {
      label: 'Geschenkkartencode',
    },
  },
  buttons: {
    check_balance: 'Guthaben prüfen',
  },
};
